import { Component, input } from '@angular/core';

@Component({
  selector: 'app-display-like-quote',
  standalone: false,
  templateUrl: './display-like-quote.component.html',
  styleUrl: './display-like-quote.component.scss',
})
export class DisplayLikeQuoteComponent {
  readonly value = input<string>('');
}
